import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import { stackSpacing, stackStyling } from 'components/forms/new/formStyles';
import NumberField from 'components/forms/new/formikFormFields/NumberField';

const MinResourceAccountCount = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);
    const hasError = !!errors?.minBillableResourceAccounts;

    // Full Formik path including formValues wrapper
    const formikFieldPath = `formValues.${billingFieldPaths.MIN_RESOURCE_ACCOUNT_COUNT}`;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel
                    sx={{ ...formLabelStyling(darkMode), paddingTop: '12px' }}>
                    Contracted Minimum Resource
                    <br /> Account Count
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field name={formikFieldPath}>
                        {({ field }) => (
                            <NumberField
                                {...field}
                                min={0}
                                customWidth="100%"
                                darkMode={darkMode}
                                value={
                                    billingSettings?.minBillableResourceAccounts ||
                                    0
                                }
                                onChange={(e) =>
                                    updateFormData(
                                        billingFieldPaths.MIN_RESOURCE_ACCOUNT_COUNT,
                                        parseInt(e.target.value, 10) || 0,
                                    )
                                }
                            />
                        )}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter contracted minimum resource account count for this company"
                        ariaLabel="minresourceaccountcount-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default MinResourceAccountCount;
